/* Ficha B: formulario nativo mejorado; el carrito conserva su contrato compartido. */
(() => {
  'use strict';
  document.querySelectorAll('[data-hs-ficha]').forEach(ficha => {
    if (ficha.dataset.iniciada) return;
    ficha.dataset.iniciada = 'true';
    const producto = JSON.parse(ficha.querySelector('[data-hs-producto-json]').textContent);
    const form = ficha.querySelector('form');
    const id = form.querySelector('[data-hs-variante]');
    id.disabled = false;
    const cantidad = form.elements.quantity;
    const principal = ficha.querySelector('[data-hs-submit]');
    const fijo = ficha.querySelector('[data-hs-submit-fijo]');
    const barra = ficha.querySelector('[data-hs-barra-producto]');
    const error = ficha.querySelector('[data-hs-error]');
    const campos = [...ficha.querySelectorAll('[data-hs-opcion]')];
    const pista = ficha.querySelector('[data-hs-galeria]');
    const imagenes = [...pista.children];
    let variante = producto.variants.find(v => String(v.id) === id.value);
    let ocupado = false;
    ficha.querySelector('[data-hs-opciones]')?.removeAttribute('hidden');

    function mostrarImagen(indice) {
      pista.scrollTo({ left: imagenes[indice].offsetLeft - pista.offsetLeft, behavior: 'instant' });
      indicar(indice);
    }
    function indicar(indice) {
      const indicador = ficha.querySelector('[data-hs-indicador]');
      const texto = `${indice + 1} / ${imagenes.length}`;
      if (indicador.textContent !== texto) indicador.textContent = texto;
      ficha.querySelectorAll('[data-hs-miniatura]').forEach((boton, i) => boton.setAttribute('aria-pressed', String(i === indice)));
    }
    pista.addEventListener('scroll', () => indicar(Math.max(0, Math.min(imagenes.length - 1, Math.round(pista.scrollLeft / pista.clientWidth)))));
    ficha.querySelectorAll('[data-hs-miniatura]').forEach((boton, indice) => boton.addEventListener('click', () => mostrarImagen(indice)));
    function precio(contenedor, centavos) {
      const span = document.createElement('span');
      span.className = 'money'; span.textContent = '$' + (centavos / 100).toFixed(2);
      contenedor.querySelector(':scope > .money').replaceWith(span);
    }
    function actualizar(reemplazarPrecio) {
      const disponible = Boolean(variante?.available);
      principal.disabled = fijo.disabled = ocupado || !disponible;
      principal.textContent = disponible ? 'Añadir al carrito' : 'Agotado';
      fijo.textContent = disponible ? 'Añadir' : 'Agotado';
      const stock = ficha.querySelector('[data-hs-stock]');
      stock.textContent = disponible ? 'En stock' : 'Agotado';
      stock.className = 'hs-etiqueta hs-etiqueta--' + (disponible ? 'exito' : 'error');
      const sku = variante?.sku?.trim() || '';
      ficha.querySelector('[data-hs-sku]').textContent = sku;
      ficha.querySelector('[data-hs-sku-linea]').hidden = !sku;
      ficha.querySelector('[data-hs-pago]').hidden = !disponible;
      const nuevoId = String(variante?.id || '');
      const cambioId = id.value !== nuevoId;
      id.value = nuevoId; id.disabled = !variante;
      if (cambioId) id.dispatchEvent(new Event('change', { bubbles: true }));
      const opciones = campos.map(campo => campo.querySelector(':checked')?.value);
      campos.forEach((campo, indice) => campo.querySelectorAll('input').forEach(radio => {
        const disponibleValor = producto.variants.some(v => v.available && v.options.every((valor, i) => valor === (i === indice ? radio.value : opciones[i])));
        radio.closest('label').dataset.agotada = String(!disponibleValor);
      }));
      if (!variante) return;
      const listas = ficha.querySelector('[data-hs-listas]');
      listas.dataset.productVariantId = String(variante.id);
      listas.querySelector('.data-json-product').textContent = JSON.stringify({ handle: producto.handle, default_variant_id: variante.id });
      if (!reemplazarPrecio) return;
      const actual = ficha.querySelector('[data-hs-precio-ficha] .hs-precio');
      precio(actual, variante.price);
      actual.querySelector('s')?.remove();
      if (variante.compare_at_price > variante.price) {
        const antes = document.createElement('s'); antes.className = 'hs-precio__antes';
        const span = document.createElement('span'); span.className = 'money'; span.textContent = '$' + (variante.compare_at_price / 100).toFixed(2);
        antes.append(span); actual.append(antes);
      }
      precio(barra.querySelector('.hs-precio'), variante.price);
      const url = new URL(location.href); url.searchParams.set('variant', variante.id); history.replaceState({}, '', url);
      if (variante.featured_image) {
        const indice = imagenes.findIndex(img => String(variante.featured_image.id) === img.dataset.hsImagen);
        if (indice >= 0) mostrarImagen(indice);
      }
    }
    campos.forEach(campo => campo.addEventListener('change', () => {
      const opciones = campos.map(c => c.querySelector(':checked')?.value);
      variante = producto.variants.find(v => v.options.every((valor, i) => valor === opciones[i]));
      actualizar(true);
    }));
    function normalizarCantidad() {
      cantidad.value = String(Math.max(1, Math.floor(Number(cantidad.value) || 1)));
      return Number(cantidad.value);
    }
    cantidad.addEventListener('change', normalizarCantidad);
    ficha.querySelectorAll('[data-hs-cantidad]').forEach(boton => boton.addEventListener('click', () => {
      cantidad.value = String(Math.max(1, normalizarCantidad() + Number(boton.dataset.hsCantidad)));
    }));
    form.addEventListener('submit', async evento => {
      evento.preventDefault();
      if (!variante?.available || ocupado) return;
      ocupado = true; actualizar(false); error.hidden = true;
      try {
        await window.HS.carrito.agregar(variante.id, normalizarCantidad());
        window.HS.carrito.abrir();
      } catch (fallo) { error.textContent = fallo.message || 'No se pudo añadir el producto.'; error.hidden = false; }
      finally { ocupado = false; actualizar(false); }
    });
    fijo.addEventListener('click', () => form.requestSubmit(principal));
    const movil = matchMedia('(max-width: 767px)');
    let fuera = false;
    function actualizarBarra() { barra.hidden = !movil.matches || !fuera; }
    const observador = new IntersectionObserver(entradas => {
      const entrada = entradas[entradas.length - 1];
      if (!entrada) return;
      fuera = !entrada.isIntersecting && entrada.boundingClientRect.bottom < 0;
      actualizarBarra();
    });
    observador.observe(principal); movil.addEventListener('change', actualizarBarra);
    ficha.querySelectorAll('[data-hs-descripcion] table').forEach(tabla => {
      const envoltorio = document.createElement('div'); envoltorio.className = 'hs-ficha__tabla';
      envoltorio.tabIndex = 0; envoltorio.setAttribute('role', 'region'); envoltorio.setAttribute('aria-label', 'Tabla de especificaciones, desplazamiento horizontal');
      tabla.before(envoltorio); envoltorio.append(tabla);
    });
    actualizar(false);
    if (variante?.featured_image) {
      const indice = imagenes.findIndex(img => String(variante.featured_image.id) === img.dataset.hsImagen);
      if (indice >= 0) mostrarImagen(indice);
    }
  });

})();
